<template >
    <vx-card>
        <vs-popup  class="con-vs-popup bg-box-gradient-popup"  title="¿Hablamos?" :active.sync="callServicePopup">
            <call-service-popup
                v-bind:callServicePopup="callServicePopup"
                v-bind:callServiceType="callServiceType"
                @closeCallServicePopup="closeCallServicePopup"
            >
            </call-service-popup>
          </vs-popup>
        <div class="box-buttons-cambio" > 
            <div class="squared-button" v-if="previus">
                <vs-button
                @click="goToPreviusStep()"
                >
                Anterior</vs-button>
            </div>
            <div class="call-button-cambio">
                <vs-button 
                    @click="callService()"
                >
                <img src="../../../../assets/images/logo/call-phone-icon.png" width="20px" height="20px"/>
                    Solicitar llamada
                </vs-button>
            </div>
            <div class="squared-button" v-if="next"> 
                <vs-button v-if="next == 'signaturit'"
                @click="goToNextStep()">
                Contratar</vs-button>

                <vs-button v-else
                @click="goToNextStep()"
                >
                Siguiente</vs-button>
            </div>
        </div>
    </vx-card>
</template>
<script>
import VxCard from '../../../../components/vx-card/VxCard.vue'
/* eslint-disable */ 
import Button from '../../vuesax/button/Button.vue'
import CallServicePopup from '../callServicePopup/CallServicePopup.vue'
export default {
  components: { Button, VxCard, CallServicePopup },
    name: 'navegation-buttons',
    props: {
        next: String,
        previus: String,
        // step: Number,
        code: String,
    },
    data() {
        return {
            callServicePopup: false,
            callServiceType:"helpProcess"
        }

    },
    
    methods: {
         goToPreviusStep() {
            this.$router
            .push("/"+ this.previus + "-step/" + this.code)
            .catch(() => {});
        },
        callService() {
            this.callServicePopup = true;

        },
        closeCallServicePopup(value){
            this.callServicePopup = value;
        },
        goToNextStep() {
            this.$emit("nextStep")

        //   this.$router
        //     .push("/" + this.next + "-step/" + this.code)
        //     .catch(() => {});
        }
    }
}
</script>
<style lang="scss">

// .box-buttons-cambio{
//     display: flex;
//     flex-direction: row;
//     justify-content: space-between;
//     flex-wrap: nowrap;
//     align-items: center;
//     margin-top: 20px;
//     padding-left: 20px;
//     padding-right: 20px;
// }

// .no-fill-button {
//     .vs-button-primary.vs-button-filled {
//         background: none !important
//         }
//     }

// .back-button-cambio .vs-button{
//   background-color: white;
//   color: rgba(var(--vs-secundary), 1) !important;
//   border: 1px solid rgba(var(--vs-secundary), 1) !important;
//   font-weight: bold;
//   padding: 5px 40px !important;
//   height: 40px !important;
//   margin-bottom: 20px;
// }

// .call-button-cambio .vs-button{
//     background-color: white;
//     border: 1.5px solid #b0b0b0 !important;
//     border-radius: 8px;
//     padding: 4px 10px !important;
//     // border: none;
//     font-weight: 530;
//     height: 42px !important;
//     font-size: 13px;
//     margin-bottom: 20px;
//     font-family: "Montserrat", Helvetica, Arial, sans-serif;
//     .vs-button--text{
//         color: black;
//         opacity: 0.8;
//     }
//     img{
//         display:inline;
//         width: 15px;
//         height: 15px;
//         margin-right: 0px;
//     }
// }

// .next-button-cambio .vs-button{
//   background-color: white;
//   color: rgba(var(--vs-secundary), 1) !important;
//   border: 1px solid rgba(var(--vs-secundary), 1) !important;
//   font-weight: bold;
//   padding: 5px 40px !important;
//   height: 40px !important;
//   margin-bottom: 20px;
// }

// @media only screen and (max-width: 600px) {
//     .box-buttons-cambio{
//         display: flex;
//         flex-direction: column;
//         justify-content: space-around;
//         flex-wrap: nowrap;
//         align-items: center;
//     }

    
// } 

</style>